import { render } from "./ModalAiProofreaderLogin.vue?vue&type=template&id=34b6e8e7&lang=pug"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__